<template>
	<div class="bg-white px-3 pt-2" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<el-button type="primary" size="mini">查询</el-button>
		<!-- 头部标签页 -->
		<el-tabs v-model="tabIndex" @tab-click="getList"><el-tab-pane :label="tab.name" :key="tabI" v-for="(tab, tabI) in tabbars"></el-tab-pane></el-tabs>

		<!-- 商品列表 -->
		<el-table class="" :data="tableData" style="width: 100%;" @selection-change="handleSelectionChange" size="mini" key="table1" :max-height="maxHeight">
			<el-table-column type="selection" width="45" align="center"></el-table-column>
			<el-table-column align="center" prop="id" width="60" label="编号" fixed="left"></el-table-column>
			<el-table-column prop="cpmc" width="180" label="产品名称"></el-table-column>
			<el-table-column align="center" prop="cpbm" label="产品编码"></el-table-column>
			<el-table-column align="center" prop="ggmc" label="规格名称"></el-table-column>
			<el-table-column align="center" prop="ggbm" label="规格编号"></el-table-column>
			<el-table-column align="center" prop="dw" label="单位"></el-table-column>
			<el-table-column align="center" prop="sl" label="数量"></el-table-column>
			<el-table-column align="center" prop="llsl" label="领料数量"></el-table-column>
			<el-table-column align="center" label="产品类型">
				<template slot-scope="scope">
					<el-button type="info" size="mini" plain v-if="scope.row.cplx == 0">常规商品</el-button>
					<el-button type="success" size="mini" plain v-else-if="scope.row.cplx == 1">生产成品</el-button>
					<el-button type="danger" size="mini" plain v-else>生产原料</el-button>
				</template>
			</el-table-column>
			<el-table-column align="center" width="120" label="关联生产单">
				<template slot-scope="scope">
					<el-button type="success" size="mini" plain>{{scope.row.scbh}}</el-button>
				</template>
			</el-table-column>
			<!-- 操作 -->
			<el-table-column align="center" label="操作" fixed="right" width="100">
				<template slot-scope="scope">
					<div v-if="tab != 'delete'">
						<el-button type="primary" size="mini" @click="openModel(scope.row)">查看</el-button>
					</div>
					<div v-else>暂无操作</div>
				</template>
			</el-table-column>
		</el-table>
		<div style="height: 60px;"></div>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 250px;right: 0;z-index: 100;">
			<div style="flex: 1;" class="px-2">
				<el-pagination
					:current-page="page.current"
					:page-sizes="page.sizes"
					:page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="page.total"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
				></el-pagination>
			</div>
		</el-footer>
		<el-dialog title="查看" :visible.sync="createModel" top="10vh" width="160vh">
			<!-- 表单内容 -->
			<div style="width: 100%;" class="d-flex">
				<div style="width: 33%;">
					<el-form ref="form" :model="form" label-width="80px">
						<el-form-item label="信息编号"><el-input v-model="form.id" size="mini" style="width: 95%;"></el-input></el-form-item>
						<el-form-item label="产品编码"><el-input v-model="form.cpbm" size="mini" style="width: 95%;"></el-input></el-form-item>
						<el-form-item label="单位"><el-input v-model="form.dw" size="mini" style="width: 95%;"></el-input></el-form-item>
						<el-form-item label="关联生产">
							<el-button type="success" size="mini">{{form.scbh}}</el-button>
						</el-form-item>
						<el-form-item label="入库数量"><el-input v-model="form.rksl" size="mini" style="width: 95%;"></el-input></el-form-item>
					</el-form>
				</div>
				<div style="width: 33%;">
					<el-form ref="form" :model="form" label-width="80px">
						<el-form-item label="创建时间"><el-input v-model="form.create_time" size="mini" style="width: 95%;"></el-input></el-form-item>
						<el-form-item label="规格名称"><el-input v-model="form.ggmc" size="mini" style="width: 95%;"></el-input></el-form-item>
						<el-form-item label="数量"><el-input v-model="form.sl" size="mini" style="width: 95%;"></el-input></el-form-item>
						<el-form-item label="关联产品">
							<el-button type="success" size="mini">{{form.cpmc}}</el-button>
						</el-form-item>
					</el-form>
				</div>
				<div style="width: 33%;">
					<el-form ref="form" :model="form" label-width="80px">
						<el-form-item label="产品名称"><el-input v-model="form.cpmc" size="mini" style="width: 95%;"></el-input></el-form-item>
						<el-form-item label="规格编码"><el-input v-model="form.ggbm" size="mini" style="width: 95%;"></el-input></el-form-item>
						<el-form-item label="产品类型">
							<el-button type="info" size="mini" plain v-if="form.cplx == 0">常规商品</el-button>
							<el-button type="success" size="mini" plain v-else-if="form.cplx == 1">生产成品</el-button>
							<el-button type="danger" size="mini" plain v-else>生产原料</el-button>
						</el-form-item>
						<el-form-item label="领料数量"><el-input v-model="form.llsl" size="mini" style="width: 95%;"></el-input></el-form-item>
					</el-form>
				</div>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import buttonSearch from '@/components/common/button-search.vue'; // 引入 按钮、搜索、高级搜索组件
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	mixins: [common], // 引入mixins里的common.js
	inject: ['layout'], // 依赖注入
	// 引入注册
	components: {
		buttonSearch
	},
	data() {
		return {
			preUrl: 'scddcp', // api
			tabIndex: 0,
			tabbars: [
				{ name: '全部', key: 'all' },
				{ name: '成品', key: 'cp' },
				{ name: '原料', key: 'yl' },
				{ name: '常规', key: 'cg' },
			],
			form: {},
			tableData: [],
			createModel: false,
			maxHeight: 0,
		};
	},
	filters: {
		tree(item) {
			if (item.level == 0) {
				return item.name;
			}
			let str = '';
			for (let i = 0; i < item.level; i++) {
				str += i == 0 ? '|--' : '--';
			}
			return str + ' ' + item.name;
		}
	},
	// 计算属性
	computed: {
		// 引入store-modules的user模块里面的user(存储用户相关的数据)
		...mapState({
			user: state => state.user.user,
			navBar: state => state.menu.navBar
		}),
		// 订单类型
		tab() {
			return this.tabbars[this.tabIndex].key; //拿到key值，用来高级搜索
		},
		params() {
			let str = '';
			for (let key in this.form) {
				let val = this.form[key];
				if (val) {
					str += `&${key}=${this.form[key]}`;
				}
			}
			return str;
		}
	},

	// 生命周期监听页面
	mounted() {
		this.$nextTick(() => {
			this.maxHeight = window.innerHeight - 274; //300是页面中除了表格外其他组件的高度
		});
	},
	methods: {
		// 获取请求列表分页url
		getListUrl() {
			return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}&tab=${this.tab}${this.params}`;
		},
		// 获取列表 可修改
		getListResult(e) {
			console.log(this.user);
			this.tableData = e.list;
		},
		// 清空筛选条件
		clearSearch() {
			this.form = {
				title: '',
				category_id: ''
			};
		},
		// 搜索事件
		searchEvent(e = false) {
			// 简单搜索
			if (typeof e === 'string') {
				this.form.title = e;
			}
			// 高级搜索
			this.getList();
		},
		openModel(e = false) {
			console.log(e);
			this.form = e
			// 打开dialog
			this.createModel = true;
		}
	}
};
</script>

<style>
.el-collapse-item__header {
	/* display: flex; */
	align-items: center;
	height: 48px;
	line-height: 48px;
	margin-left: 10px;
	cursor: pointer;
	font-size: 13px;
	/* font-weight: 500; */
	transition: border-bottom-color 0.3s;
	outline: 0;
}
.demo-table-expand {
	font-size: 0;
}
.demo-table-expand label {
	width: 90px;
	color: #99a9bf;
}
.demo-table-expand .el-form-item {
	margin-right: 0;
	margin-bottom: 0;
	width: 50%;
}
.el-dropdown-link {
    cursor: pointer;
    color: #ff8c00;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
</style>
